import angular from 'angular'

import component from './edit-vehicle.component'

let module = angular.module('myGarageEditVehicleModule', [])

.component('myGarageEditVehicle', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-garage/components/edit-vehicle/index.js